import { type FC } from "react";

import { type MyLensesSubmissionError } from "../../../../gql-generated/types";
import { PageContentSpinner } from "../../../../layout/components";

import { LensSubmissionErrorMessageItem } from "./LensSubmissionErrorMessageItem";
import { LensSubmissionErrorsContainer } from "./LensSubmissionErrorsBody.styles";
import { UnknownErrors } from "./UnknownErrors";

export const LensSubmissionErrorsBody: FC<{ submissionErrors: MyLensesSubmissionError[]; errorsLoading: boolean }> = ({
    submissionErrors,
    errorsLoading,
}) => {
    if (errorsLoading) {
        return <PageContentSpinner height={"548px"} />;
    }

    return submissionErrors.length > 0 ? (
        <LensSubmissionErrorsContainer>
            {submissionErrors.map((submissionError, key) => (
                <LensSubmissionErrorMessageItem
                    key={key}
                    heading={submissionError.heading}
                    message={submissionError.message}
                />
            ))}
        </LensSubmissionErrorsContainer>
    ) : (
        <UnknownErrors />
    );
};
